export const SYSTEM_USER = { id: '__SYSTEM__', name: 'System user' }
